
    <div class="modal-header AlertModalHeader">{{ title }}</div>
    <div class="modal-body AlertModalBody">{{ message }}</div>
    <div class="modal-footer">
      <span type="button" class="ColorBlue CursorPointer mr-4" (click)="decline()">{{ btnCancelText }}</span>
      <button type="button" class="BtnBlue CursorPointer" (click)="accept()">{{ btnOkText }}</button>
    </div>
  